export const DURATION_UNITS = ['d', 'h', 'm', 's'] as const;
export type DurationUnit = (typeof DURATION_UNITS)[number];
